import {Router} from "vue-router";
import {objectEntries, objectKeys} from "@antfu/utils";
import moment from "moment";
import {da} from "vuetify/locale";
import { router } from '@/plugins/1.router/index'
import { userAbilityRulesStorage } from '@layouts/plugins/casl'

export function toCode(val: string) {
  if (val === null || typeof val !== 'string') {
    return val
  }
  const pos = val.indexOf(CODE_DELIMETER)
  if (pos > -1) {
    return val.substring(0, pos)
  }
  return val
}


export function toText(val: string) {
  if (val === null || typeof val !== 'string') {
    return val
  }
  const pos = val.indexOf(CODE_DELIMETER)
  if (pos === -1) {
    return val
  }
  if (pos === 0) {
    return '' // 沒有代碼
  }
  return val.substring(pos + CODE_DELIMETER.length) || toCode(val)
}

export function toMultiText(val: string) {
  if (val != null && typeof val == 'string' && val.includes(';')) {
    const valAry = val.split(';')
    return valAry.map(it => toText(it)).join(';')
  }
  return toText(val)
}

export function toCodeText(code: string, text: string) {
  return code + CODE_DELIMETER + text
}


export function fetchTableHeaders(vo, pug) {
  if (pug.template === 'SingleTable') {
    if (pug['drawer-layout']) {
      const headers = pug['drawer-layout'].grid.fields.field.map(f => {
        f.title = vo[f.class].label
        f.field = f.class
        f.key = f.class
        f.headerName = vo[f.class].label
        f.colId = f.class
        return f
      })
      headers.push({title: '操作', key: 'actions', sortable: false})

      return headers
    } else {
      const headers = pug.grid.fields.field.map(f => {
        f.title = vo[f.class].label
        f.field = f.class
        f.key = f.class
        f.headerName = vo[f.class].label
        f.colId = f.class
        return f
      })
      headers.push({title: '操作', key: 'actions', sortable: false})

      return headers
    }
  }
  return []
}

export function fetchFormFields(vo, pug) {
  if (pug.template === 'SingleTable') {
    if (pug['drawer-layout']) {
      const fields = pug['drawer-layout'].form.row.flatMap((element) => element.field).flat().map(f => {
        const field = {...f, ...vo[f.class]}
        return field
      })

      return fields
    } else {
      const fields = pug.form.row.flatMap((element) => element.field).flat().map(f => {
        const field = {...f, ...vo[f.class]}
        return field
      })

      return fields
    }

  }
  return []
}

export function fetchQueryFields(vo, pug) {
  if (pug.template === 'SingleTable') {
    const fields = pug['query'].field.map(f => {
      const field = {...f, ...vo[f.class]}
      return field
    })

    return fields
  }
  return []
}


export function transPickerSearchColumns(searchColumns) {
  let cols = {}
  searchColumns.forEach(it => cols[it] = '')
  return cols
}


export function doLogout(importRouter?: Router, returnPath?: string|null) {
  localStorage.clear()
  useStorage('userData', {}).value = null
  useCookie('userToken').value = null
  // 使用共享的 ref 清空，確保與 isHidden 函數同步
  userAbilityRulesStorage.value = []
  // 嘗試使用傳入的 router，如果沒有則使用 useRouter()，最後使用導入的 router
  let routerInstance = importRouter
  if (!routerInstance) {
    try {
      routerInstance = useRouter()
    } catch (error) {
      console.warn('useRouter() failed:', error)
      routerInstance = router
    }
  }
  
  // 使用 nextTick 確保狀態更新後再重定向
  nextTick(() => {
    window.location.href = '/login'
  //   if (routerInstance) {
  //     if (!!returnPath) {
  //       routerInstance.push({
  //         name: 'login',
  //         query: { 
  //           to: returnPath 
  //         }
  //       })
  //     } else {
  //       routerInstance.push({ name: 'login' })
  //     }
  //   } else {
  //     // 如果所有 router 都不可用，使用 window.location 進行重定向
  //     console.warn('No router available, using window.location')
  //     window.location.href = '/login'
  //   }
  })
}

export function isEmptyString(val: string) {
  return !val || val == null || val == ''
}

export function isEmptyObject(val: any) {
  return !objectEntries(val).map(it => isEmptyString(it[1])).includes(false)
}

// 西元年轉民國年
export function convertToROCDate(dateString, separator: string) {
  if (!dateString) {
    return '';
  }
  if (dateString.length < 8) {
    return '';
  }
  const datePart = dateString.slice(0, 8);
  if (!/^\d{8}$/.test(datePart)) {
    return '';
  }
  const year = parseInt(datePart.slice(0, 4), 10);
  const monthDay = datePart.slice(4);
  const month = datePart.slice(4,6);
  const day = datePart.slice(6);
  const rocYear = year - 1911;
  if (rocYear <= 0) {
    return '';
  }
  const rocYearStr = rocYear < 100 ? ('0' + rocYear).slice(-3) : rocYear.toString();
  if (!separator) {
    return rocYearStr + monthDay;
  }

  return `${rocYearStr}${separator}${month}${separator}${day}`;

}

// 民國年轉西元年
export function convertToADDate(dateString: string, separator: string = '-') {
  console.log('convertToADDate: ', dateString, separator)
  if (!dateString) {
    return '';
  }
  if (!dateString.includes(separator)) {
    if (dateString.length > 7) {
      return dateString;
    } else {
      dateString = `${dateString.substring(0, 3)}${separator}${dateString.substring(3, 5)}${separator}${dateString.substring(5)}`
    }
  }
  const dateParts = dateString.split(separator)
  const year = parseInt(dateParts[0]);
  const month = dateParts[1];
  const day = dateParts[2];
  const adYear = year + 1911;

  const adYearStr = `${adYear}${month}${day}`
  return adYearStr;
}

export function datetimeFormat(val, format) {
  const formatVal = moment(val).format(format)
  if (formatVal.includes('Invalid ') ) {
    return val
  }
  return formatVal
}

export async function mapFileDownload (fileURL: string|null, fileId: string){
  if(!fileURL) {
    console.log('fileURL is null')
    return '';
  }
  let localUrl = useStorage('drFsUrl').value
  let url = fileURL??localUrl
  const jwt = await useJwt()
  return `${url}${DOWNLOAD_URL}${fileId}?drJwt=${jwt.value}`
}

export async function copyPlainText(text: string | null | undefined): Promise<boolean> {
  if (!text || typeof window === 'undefined') {
    return false
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }

    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()

    const copied = document.execCommand('copy')
    document.body.removeChild(textarea)

    return copied
  } catch (error) {
    console.error('copyPlainText failed:', error)
    return false
  }
}

/** 協會申請窗口：主職稱或兼任職稱符合 SubmissionAsContact */
export function isAssociationContact(
  user: { postNo?: string; postNo2?: string } | null | undefined,
  contactPostNo: unknown,
): boolean {
  const contact =
    contactPostNo != null && typeof contactPostNo === 'object' && 'value' in (contactPostNo as object)
      ? (contactPostNo as { value: unknown }).value
      : contactPostNo
  if (!user || contact == null || contact === '') {
    return false
  }
  return user.postNo == contact || user.postNo2 == contact
}
